import { FC, useMemo, useState } from "react";
import { Box, Link, Typography, useTheme } from "@mui/material";

import PageTitle from "../../../components/PageTitle";
import SearchField from "../../../components/ui/SearchField";
import { filterFaq, WHATSAPP_URL } from "./support-data";
import SupportChannels from "./components/SupportChannels";
import SupportFaq from "./components/SupportFaq";

const SupportPage: FC = () => {
  const theme = useTheme();
  const [search, setSearch] = useState("");
  const filteredFaq = useMemo(() => filterFaq(search), [search]);

  return (
    <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
      <PageTitle title="Suporte" />

      {/* Hero + busca */}
      <Box
        sx={{
          background: theme.palette.brand.heroBg,
          border: `1px solid ${theme.palette.brand.heroBorder}`,
          borderRadius: "18px",
          p: { xs: "28px 20px", md: "32px 40px" },
          textAlign: "center",
          maxWidth: 860,
          mx: "auto",
          mb: 4,
        }}
      >
        <Typography sx={{ fontFamily: theme.typography.fontFamilyDisplay, fontSize: 30, color: "text.primary", mb: 1 }}>
          Como podemos ajudar?
        </Typography>
        <Typography sx={{ fontSize: 15, color: "text.secondary", mb: 3 }}>Encontre respostas rápidas ou fale com a nossa equipe.</Typography>
        <Box sx={{ maxWidth: 440, mx: "auto" }}>
          <SearchField value={search} onChange={setSearch} placeholder="Buscar na central de ajuda..." />
        </Box>
      </Box>

      <SupportChannels />

      <SupportFaq items={filteredFaq} onClearSearch={() => setSearch("")} />

      {/* Footer */}
      <Box sx={{ maxWidth: 860, mx: "auto", textAlign: "center", pb: 2 }}>
        <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
          Não encontrou o que procurava?{" "}
          <Link
            component="button"
            onClick={() => window.open(WHATSAPP_URL, "_blank")}
            sx={{ fontSize: 14, color: "primary.main", fontWeight: 600, textDecoration: "none", cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
          >
            Fale com a nossa equipe
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default SupportPage;
